export default "__VITE_ASSET__yRwIVmzb__"